
import { Component, Vue } from "vue-property-decorator";
import copyToClipboard from 'quasar/src/utils/copy-to-clipboard.js';;
import AdminPartnerStatCard from "@/components/admin/AdminPartnerStatCard.vue";

@Component({
  components: { AdminPartnerStatCard }
})
export default class AdminHome extends Vue {
  startTime: number = new Date().setHours(0, 0, 0, 0);
  endTime: number = Date.now() + 24 * 60 * 60 * 1000;

  providerOfferKeys = [
    "price_RUB",
    "price_USD",
    "boughtPrice_USD",
    "profit_USD",
    "marginPercent"
  ];

  formatNumber(value) {
    return Number(value || 0).toLocaleString("ru-RU", {
      maximumFractionDigits: 2
    });
  }

  // Строки карточки офферов партнёра: суммы выводов и депозитов в рублях
  offerRows(val) {
    return ["WITHDRAW", "DEPOSIT"].map(key => ({
      label: key,
      value: val[key],
      unit: "₽"
    }));
  }

  providerOfferRows(providerVal) {
    return this.providerOfferKeys.map(key => ({
      label: key,
      value: providerVal[key],
      unit: key.includes("USD") ? "$" : key.includes("Percent") ? "%" : "₽"
    }));
  }

  copy(obj: any, fields?: string[]) {
    let result = {};

    if (fields?.length) {
      result["partnerName"] = obj.partnerUser.name;

      fields.forEach(field => {
        result[field] = obj[field];
      });
    } else {
      result = obj;
    }

    copyToClipboard(JSON.stringify(result, null, 2));
    this.$q.notify({ message: "Скопировано в буфер обмена", color: "green" });
  }

  get dateModel() {
    return [{ from: this.fromDate, to: this.toDate }];
  }

  set dateModel(value) {
    if (!value) {
      this.startTime = new Date().setHours(0, 0, 0, 0);
      this.endTime = Date.now() + 24 * 60 * 60 * 1000;
    } else {
      //@ts-ignore
      const { from, to } = value;
      if (from && to) {
        this.fromDate = from;
        this.toDate = to;
      }
    }
  }

  get fromDate() {
    //@ts-ignore
    return this.$options.filters.moment(this.startTime, "YYYY/MM/DD");
  }

  set fromDate(value) {
    this.startTime = new Date(value).getTime();
  }

  get toDate() {
    //@ts-ignore
    return this.$options.filters.moment(this.endTime, "YYYY/MM/DD");
  }
  set toDate(value) {
    this.endTime = new Date(value).getTime();
  }
}
